<template>
  <div v-if="show" class="modal-overlay modal-overlay-elevated" @click.self="$emit('cancel')">
    <!-- Dialog -->
    <div class="modal-content" role="dialog" aria-modal="true" :aria-labelledby="'confirm-title-' + Math.random()">
      <div class="modal-header">
        <div class="flex items-center">
          <div class="flex-shrink-0 w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
            <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h3 class="text-section-header" :id="'confirm-title-' + Math.random()">{{ title }}</h3>
        </div>
        <button @click="$emit('cancel')" class="modal-close-button" :disabled="loading" aria-label="Close dialog">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="text-body text-gray-600">{{ message }}</p>
      </div>

      <div class="modal-footer">
        <button @click="$emit('cancel')" class="btn-secondary flex-1" :disabled="loading">
          Cancel
        </button>
        <button @click="$emit('confirm')"
          class="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-200 cursor-pointer disabled:opacity-50 flex-1"
          :disabled="loading">
          {{ loading ? 'Deleting...' : confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBodyScrollLock } from '../composables/useBodyScrollLock'

const props = defineProps<{
  show: boolean
  title: string
  message: string
  confirmText?: string
  loading?: boolean
}>()
useBodyScrollLock(() => props.show)

defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
}>()
</script>
